export enum ComponentsTypes {
  ACCORDION = 'accordion',
  ACCORDION_LIST = 'accordion_list',
  ADDRESS = 'address',
  ALERT = 'alert',
  ANNUALIZED_MILEAGE = 'annualized_mileage',
  AUTOCOMPLETE_DROPDOWN = 'autocomplete_dropdown',
  BRAINTREE_INPUT = 'braintree_input',
  BIND_FORM = 'bind_form',
  CARD = 'card',
  CARD_CONTENT = 'card_content',
  CAROUSEL = 'carousel',
  CAROUSEL_TILE = 'carousel_tile',
  CHECKBOX = 'checkbox',
  CHIP_GROUP = 'chip_group',
  CIRCULAR_PROGRESS = 'circular_progress',
  COVERAGE_SECTION = 'coverage_section',
  COVERAGE_SCENE_WRAPPER = 'coverage_scene_wrapper',
  COVERAGE_CHECKBOX = 'coverage_checkbox',
  COVERAGE_SELECT_DROPDOWN = 'coverage_select_dropdown',
  COVERAGE_CHIP_GROUP = 'coverage_chip_group',
  DATE_PICKER = 'date_picker',
  EMAIL_INPUT = 'email_input',
  EXTERNAL_IMAGE = 'external_image',
  EXPANDABLE_CONTAINER = 'expandable_container',
  FORM = 'form',
  ACTION_FORM = 'action_form',
  IMAGE = 'image',
  INERT_ICON = 'inert_icon',
  INFO_CARD = 'info_card',
  PRICE_CARD = 'price_card',
  LAYOUT = 'layout',
  LIST = 'list',
  LOADER = 'loader',
  MOCK_DATA_WRAPPER = 'mock_data_wrapper',
  STEP = 'step',
  STEPPED_LOADER = 'stepped_loader',
  MEDIA_ALPHA_RESELL = 'media_alpha_resell',
  MODAL = 'modal',
  NUMBER_INPUT = 'number_input',
  PHONE_INPUT = 'phone_input',
  POLICY_EFFECTIVE_DATE_PICKER = 'policy_effective_date_picker',
  PRICE = 'price',
  RADIO = 'radio',
  READ_MORE = 'read_more',
  READONLY_COVERAGE_VALUE = 'readonly_coverage_value',
  READONLY_COVERAGE_CHECKBOX = 'readonly_coverage_checkbox',
  READONLY_COVERAGE_CHIP_GROUP = 'readonly_coverage_chip_group',
  RICH_TEXT = 'rich_text',
  SELECT_DROPDOWN = 'select_dropdown',
  SKELETON = 'skeleton',
  FIXED_CONTAINER = 'fixed_container',
  SUCCESS_ANIMATION = 'success_animation',
  SWITCH = 'switch',
  TAB = 'tab',
  TAB_LIST = 'tab_list',
  TAB_PANEL = 'tab_panel',
  TEXT_INPUT = 'text_input',
  TOAST = 'toast',
  TYPOGRAPHY = 'typography',
  VIN_IMAGE = 'vin_image',
  BRIDGE_EVENT_COMMUNICATOR = 'bridge_event_communicator',
}

export const READONLY_COMPONENT_TYPES: ComponentsTypes[] = [
  ComponentsTypes.READONLY_COVERAGE_VALUE,
  ComponentsTypes.READONLY_COVERAGE_CHECKBOX,
  ComponentsTypes.READONLY_COVERAGE_CHIP_GROUP,
];
